const backgroundsData = [
	{
		id: 'default',
		modifiers: []
	},
	{
		id: 'home',
		modifiers: [
			{id: 'bedroom'},
			{id: 'park-out'},
			{id: 'park-return'}
		],
	},
	{
		id: 'school',
		modifiers: [
			{id: 'classroom-2c'},
			{id: 'classroom-3c'},
			{id: 'classroom-3c-visit'},
			{id: 'classroom-3c-lunch'},
			{id: 'classroom-8a-phones'},
			{id: 'classroom-8a-issues'},
			{id: 'classroom-8a-late'},
			{id: 'classroom-8a'},
			{id: 'printer'},
			{id: 'hall-kids'},
			{id: 'hall-cleaning-lady'},
			{id: 'teachers-room-left'},
			{id: 'teachers-room-right'}
		],
	},
	{
		id: 'schoolyard',
		modifiers: [
			{id: 'playground'},
			{id: 'playground-issues'}
		]
	}
];

export {backgroundsData};